module.exports = __webpack_public_path__ + "static/img/pre.01545f41.png";